const documentPreview = {
  openInNewTab: "In neuem Tab öffnen",
  close: "Vorschau schließen",
};

export default documentPreview;
